import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { auth } from "../../../firebaseConfig";
import { getSelectedUid } from "../../../../frontend/Recruitment/Applications/Utils/UidListener";


export const readDataS5 = async () => {
   const userId = getSelectedUid(); // Get the selected UID
   if (!userId) {
     throw new Error("Invalid user.");
   }
  try {
    const docRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Accountant Details"
    );
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data(); // Return the form data
    } else {
      // console.log("No such document for Section 5!");
      return null;
    }
  } catch (error) {
    // console.error("Error fetching Section 5 data: ", error);
  }
};
